import * as types from "./types";
import { combineReducers } from "redux";

function listaColegiosEscuelas(state = [], { type, payload }) {
  return type === types.OBTENER_COLEGIOS_ESCUELAS_VACACIONES
    ? [...state, payload]
    : type === types.LIMPIAR_COLEGIOS_ESCUELAS_VACACIONES
      ? []
      : type === types.ELIMINAR_COLEGIO_LISTA_ESCUELAS_VACACIONES
        ? state.filter(item => item.id !== payload)
        : state;
}

function escuelasSinComedor(state = [], { type, payload }) {
  return type === types.ESCUELAS_SIN_COMEDOR
    ? [...state, payload]
    : type === types.LIMPIAR_ESCUELAS_SIN_COMEDOR
      ? []
      : state;
}

function escuelasConComedor(state = [], { type, payload }) {
  return type === types.ESCUELAS_CON_COMEDOR
    ? [...state, payload]
    : type === types.LIMPIAR_ESCUELAS_CON_COMEDOR
      ? []
      : state;
}

const reducer = combineReducers({
  listaColegiosEscuelas,
  escuelasSinComedor,
  escuelasConComedor
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/escuelas/reducers.js